export default "__VITE_ASSET__Zv1e4m$s__"